export type DateRangePreset = 'today' | 'yesterday' | 'lastWeek' | 'lastMonth' | string;

// Also accepts an ISO date string, parsed via the Date constructor.
export function parseDefaultDate(preset: DateRangePreset): Date {
	const today = new Date();
	const presetLower = preset.toLowerCase();

	switch (presetLower) {
		case 'today':
			return today;
		case 'yesterday': {
			const yesterday = new Date(today);
			yesterday.setDate(yesterday.getDate() - 1);
			return yesterday;
		}
		case 'lastweek': {
			const lastWeek = new Date(today);
			lastWeek.setDate(lastWeek.getDate() - 7);
			return lastWeek;
		}
		case 'lastmonth': {
			const lastMonth = new Date(today);
			lastMonth.setMonth(lastMonth.getMonth() - 1);
			return lastMonth;
		}
		default: {
			const date = new Date(preset);
			if (isNaN(date.getTime())) {
				throw new Error(`Invalid date preset: ${preset}`);
			}
			return date;
		}
	}
}

// Used for synchronous initialization of date range state.
export function getDefaultDateRange(
	fromPreset: DateRangePreset = 'lastWeek',
	toPreset: DateRangePreset = 'today',
): [string, string] {
	return [parseDefaultDate(fromPreset).toISOString(), parseDefaultDate(toPreset).toISOString()];
}
